<template>
  <Drawer direction="right" :dismissible="true" v-bind="attrs" >
    <DrawerTrigger as-child>
      <!-- <Button variant="outline">Sign In {{ app }} </Button> -->
      <Button variant="outline" @click="isDrawerOpen = true">Sign In {{ app }}</Button>
    </DrawerTrigger>

    <div v-if="isDrawerOpen" class="drawer-right">
  <div>HELLO MODAL</div>
</div>

    <DrawerContent v-if="isDrawerOpen" class="drawer-right">
      <div class="w-full max-w-sm mx-auto">
        <DrawerHeader>
          <DrawerTitle
            class="text-3xl font-semibold text-[#00CAAA] text-center"
          >
            <div v-if="backFlag" class="flex">
              <div>
                <a @click="resetForm">
                  <iconRanaBack hideBorder="true" />
                </a>
              </div>
              <div class="ml-4 text-center">Sign in to {{ app }}</div>
            </div>

            <div v-else>
              <div class="text-center">Sign in to {{ app }}</div>
            </div>
          </DrawerTitle>

          <div
            class="mt-2 h-[2px] w-64 mx-auto bg-gradient-to-r from-transparent via-[#00CAAA] to-transparent opacity-60"
          />

          <DrawerDescription class="text-center"
            >Access your account securely.</DrawerDescription
          >
        </DrawerHeader>

        <ranaTos v-model="tos" @submited="handleTos" />

        <div v-if="msgFlag" class="justify-center w-full px-2.5 mx-4">
          <!-- <Info class="w-4 h-4" />
          <h3>Info</h3> -->
          <p class="text-shadow-white" v-html="msg"></p>
        </div>

        <Alert v-if="alertFlag" variant="destructive">
          <!-- <AlertCircle class="w-4 h-4" /> -->
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>
            <p class="text-shadow-white" v-html="msg"></p>
          </AlertDescription>
        </Alert>

        <div class="p-4 pb-0 space-y-4">
          <div>
            <!-- <label for="email" class="block text-sm font-medium">Email</label> -->
            <input
              v-if="!lock"
              id="email"
              type="email"
              v-model="email"
              class="w-full px-3 py-2 mt-1 border rounded bg-background text-foreground border-border"
              placeholder="you@example.com"
            />
            <input
              v-else
              id="email"
              type="email"
              v-model="email"
              class="w-full px-3 py-2 mt-1 border rounded bg-background text-foreground border-border"
              placeholder="you@example.com"
              disabled
            />
          </div>
          <div v-if="qrImg">
            <img :src="qrImg" alt="img" class="mx-auto py-3.5" />
          </div>
          <div v-if="pinFlag">
            <PinInput
              id="pin-input"
              v-model="pin"
              placeholder="○"
              @complete="pinCall"
              class="flex justify-between w-full gap-2"
            >
              <PinInputGroup class="flex justify-between w-full gap-2">
                <PinInputSlot
                  v-for="(id, index) in 6"
                  :key="id"
                  :index="index"
                  class="w-full py-2 text-center border rounded bg-background text-foreground border-border"
                />
              </PinInputGroup>
            </PinInput>
          </div>

          <!-- Additional fields only for registration -->
          <div v-if="infoFlag" class="space-y-4">
            <!-- Date of Birth -->
            <label class="block text-sm font-medium">
              Date of Birth
              <input
                type="date"
                v-model="dateOfBirth"
                class="w-full px-3 py-2 mt-1 border rounded bg-background text-foreground border-border"
              />
            </label>

            <!-- Location -->
            <label class="block text-sm font-medium">
              Region
              <select
                v-model="region"
                class="w-full px-3 py-2 mt-1 border rounded bg-background text-foreground border-border"
              >
                <option
                  v-for="(name, code) in countryList"
                  :key="code"
                  :value="code"
                >
                  {{ name }}
                </option>
              </select>
            </label>
            <Button class="w-full" @click="submitInfo">Submit</Button>
          </div>
        </div>

        <DrawerFooter class="mt-4">
          <Button v-if="step1" class="w-1/3 mx-auto" @click="checkEmail"
            >Continue</Button
          >
          <!-- <Button v-else" class="w-full" @click="login" >Confirm</Button> -->

          <!-- <DrawerClose as-child>
            <Button variant="outline" class="w-full">Cancel</Button>
          </DrawerClose> -->
        </DrawerFooter>
      </div>
    </DrawerContent>
  </Drawer>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { Button } from "./ui/button";
import { useAttrs } from "vue";
const attrs = useAttrs();
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "./ui/drawer";

import {
  PinInput,
  PinInputGroup,
  PinInputSlot,
} from "./ui/pin-input";

import ranaTos from "./ranaTos";

import iconRanaBack from "./iconRanaBack";
// import { AlertCircle } from 'lucide-vue-next'
import { Alert, AlertDescription, AlertTitle } from "./ui/alert";
// import { Info } from "lucide-vue-next";
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import { useAuthDrawer } from "../composables/useAuthDrawer";

// defineProps({
//   app: String,
// });

const props = defineProps<{
  app?: string
}>()

defineOptions({
  inheritAttrs: false,
})

countries.registerLocale(enLocale);
const countryList = countries.getNames("en");

const email = ref("");
// const pin = ref("");
const pin = ref<string[]>([]);

const alertFlag = ref(false);
const pinFlag = ref(false);
const regFlag = ref(false);
const msgFlag = ref(false);
const lock = ref(false);
const step1 = ref(true);
const infoFlag = ref(false);
const isDrawerOpen = ref(false);
const backFlag = ref(false);

defineExpose({ open: () => { isDrawerOpen.value = true } })

const config = useRuntimeConfig();
const api = config.public.apiUrl;
const msg = ref<string | null>(null);

const fetchEmailResp = ref();

const tos = ref(false);
const userInfo = ref<{ dateOfBirth: string; region: string } | null>(null);

// proceso de registro con el QR.
const token = ref<string | null>(null);
const qrImg = ref<string | null>(null);
const valKey = ref<number>(0);

// last form
const dateOfBirth = ref("");
const region = ref("");

const alertMSG = ref(""); 

onMounted(() => {
  isDrawerOpen.value = false;
})

watch(isDrawerOpen, (open) => {
  console.log("Drawer open state changed:", open);
  if (!open) {
    resetForm();
  }
});

function resetForm() {
  email.value = "";
  pin.value = [];
  pinFlag.value = false;
  regFlag.value = false;
  msgFlag.value = false;
  lock.value = false;
  step1.value = true;
  msg.value = null;
  token.value = null;
  qrImg.value = null;
  valKey.value = 0;
  fetchEmailResp.value = null;
  dateOfBirth.value = "";
  region.value = "";
  infoFlag.value = false;
  backFlag.value = false;
  tos.value = false;
  alertMSG.value = "";
}

function clearMSG() {
  setTimeout(() => {
    // msg.value = "";
    // msgFlag.value = false;
    alertFlag.value = false;
    alertMSG.value = ""; 
  }, 5000);
}

function pinCall() {
  // methodo para saber cual methodo va a llamar el pin
  if (valKey.value === 0) {
    console.log("Me voy por login");
    login();
  } else {
    console.log("Seteamos el 2fa");
    conf2fa();
  }
}

async function checkEmail() {
  // Method for checking user email
  backFlag.value = true;

  const req = await fetch(`${api}/totp/fetch`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: email.value,
    }),
  });

  if (!req.ok) {
    // error
    console.error("Something wrong");
  }

  const resp = await req.json();

  if (resp?.registry) {
    // Prendemos el flag de registro
    regFlag.value = true; // registro
    lock.value = true; // lock email
    pinFlag.value = true; // pin visible
    msgFlag.value = true; // msg visible
    step1.value = false;
    const masked = maskEmail(email.value);
    msg.value = `Welcome to rana! <b>Verify your email</b>
      Please enter the verification code sent to: ${masked}`;
    // clearMSG();
  } else if (resp.msg === "Welcome back, please setup your 2fa.") {
    // setup 2fa
    // // token temp
    step1.value = false;
    pinFlag.value = true;
    token.value = resp?.token;
    // tambien se guarda en localstorage
    localStorage.setItem("auth_token", resp?.token);
    // llamamos setup 2 fa
    setup2fa();
  } else {
    // No registry
    lock.value = true;
    pinFlag.value = true;
    msgFlag.value = true;
    step1.value = false;
    msg.value = `
      Welcome back <b>${email.value}</b>, <br/>
      please input the code from your auth app.`;

    // clearMSG();
  }

  fetchEmailResp.value = resp;
}

function maskEmail(email: string): string {
  const [localPart, domain] = email.split("@");

  if (!localPart || !domain) return email;

  // Show first 2 and last 2 characters of local part
  const visibleStart = localPart.slice(0, 2);
  const visibleEnd = localPart.slice(-2);
  const masked = `${visibleStart}***${visibleEnd}@${domain}`;

  return masked;
}

async function login() {
  const pinCode = pin.value.join("");
  const registry = fetchEmailResp.value?.registry;

  const req = await fetch(`${api}/totp/login`, {
    method: "POST",
    body: JSON.stringify({
      email: email.value,
      secret: fetchEmailResp.value?.secret,
      code: pinCode,
      registry: fetchEmailResp.value?.registry,
    }),
  });

  if (!req.ok) {
    // error on call
    console.error("Error on call");

    if(req.status === 401) {
      // alert("Wrong pin!"); 
      pin.value = [];
      // msgFlag.value = true;
      alertFlag.value = true; 
      alertMSG.value = "Invalid Code";
      clearMSG();
    }

  }

  const resp = await req.json();

  if (!registry) {
    console.log("Not a registry ");
    // login entra al app
    // almacenamos el token
    const authToken = useAuthToken();
    const authEmail = useAuthEmail();

    if (resp?.token) {
      authToken.value = resp.token; //
      authEmail.value = email.value;
      const tokenCookie = useCookie("auth_token", { path: "/" });
      tokenCookie.value = resp.token;
      localStorage.setItem("auth_token", resp?.token);
      isDrawerOpen.value = false; // cerramos el drawer
    }
  } else {
    token.value = resp?.token;
    // tambien se guarda en localstorage
    localStorage.setItem("auth_token", resp?.token);
    // antes del 2fa seteamos la tos
    tos.value = true;
    // llamamos setup 2 fa
    setup2fa();
  }
}

async function setup2fa() {
  // llamamos el qr para establecer el 2fa.
  pin.value = []; // limpiamos pin para pasar un valor nuevo
  msgFlag.value = true; // msg visible
  valKey.value = 1;
  msg.value = `
    <b>Setup Two Factor Authentication</b>
    Scan the QR code using your auth app and enter
    the code. If you don't have one , we recomend:
    <a href="#">2fas</a>
    `;

  // clearMSG();

  //  Hacemos el get del qr
  const resp = await fetch(`${api}/totp/assign?email=${email.value}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token.value}`,
    },
  });

  if (!resp.ok) {
    console.error("Some error happen");
  }

  const qrResp = await resp.json();
  qrImg.value = qrResp?.qrUrl;
}

async function conf2fa() {
  // confirmation pin
  const pinCode = pin.value.join("");

  const params = JSON.stringify({
    email: email.value,
    code: pinCode,
  });

  const req = await fetch(`${api}/totp/verify`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token.value}`,
    },
    body: params,
  });

  if (!req.ok) {
    console.error("Some error happen");
  }

  // isDrawerOpen.value = false; // cerramos el drawer
  // mostramos el registro
  msg.value = `
    <b> Location + DOB </b>
    These are only needed to comply with local laws and regulations.
    They will remain private.
    `;
  pinFlag.value = false;
  qrImg.value = null;
  // infoFlag.value = true; // aqui se pide la info, ahora es automatico
  // ahora cerramos el modal. 
  isDrawerOpen.value = false;
}

async function handleTos(data: { dateOfBirth: string; region: string }) {
  // vemos los valores
  userInfo.value = data;
  console.log("User accepted with:", data);
  // paso el email para la fecha
  // sometemos la info
  await submitInfo(data); 
  await tosSubmission();

}

async function submitInfo(data: any) {
  const req = await fetch(`${api}/api-users/profile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token.value}`,
    },
    body: JSON.stringify({
      region: data.region,
      dateOfBirth: data.dateOfBirth,
    }),
  });

  if (!req.ok) {
    console.error("Something went wrong");
  }

  // ya lo dejamos pasar al app.
  // isDrawerOpen.value = false;
  // window.location.reload();
}

async function tosSubmission() {
  const req = await fetch(`${api}/totp/tos`, {
    method: "POST", 
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token.value}`,
    },
    body: JSON.stringify({
      email
    }),
  }); 

  if (!req.ok) {
    console.error("Something went wrong"); 
  }; 

  const resp = await req.json(); 

  console.log('====================================');
  console.log("Resp: ", resp);
  console.log('====================================');

}

</script>

<style scoped>
.drawer-right {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  max-width: 400px; /* Adjust drawer width */
  height: 100vh;
  transform: translateX(100%);
  transition: transform 0.3s ease-out;
}

.drawer-right[data-state="open"] {
  transform: translateX(0);
}

.drawer-right[data-state="closed"] {
  transform: translateX(100%);
}
</style>
